var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "title_h1" }, [_vm._v("報告書提出")]),
      _c(
        "vab-collapse-info",
        [
          _c("template", { slot: "title" }, [
            _vm._v(
              " " +
                _vm._s(_vm.getFieldValue("demandBaseIdModel.title", _vm.info)) +
                " ［ " +
                _vm._s(
                  _vm.getFieldValue(
                    "purchaseOrderBaseIdModel.acceptOrderKey",
                    _vm.info
                  )
                ) +
                " ］ "
            ),
          ]),
          _c(
            "template",
            { slot: "row" },
            [
              _c(
                "vab-row",
                { staticClass: "row_box" },
                [
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("建物")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 20 },
                    },
                    [
                      _c("div", { staticClass: "flex_space width_100" }, [
                        _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.getFieldValue(
                                  "purchaseOrderBaseIdModel.buildingCdMbuildgpModel.blgsnmkj",
                                  _vm.info
                                )
                              ) +
                              " "
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("商品")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 20 },
                    },
                    [
                      _c("div", { staticClass: "flex_space width_100" }, [
                        _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.getFieldValue(
                                  "demandBaseIdModel.itemCdModel.itmnm",
                                  _vm.info
                                )
                              ) +
                              " "
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "vab-row",
                { staticClass: "row_box" },
                [
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("案件分類")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 8 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getEnumText(
                              _vm.getFieldValue(
                                "demandBaseIdModel.businessForm",
                                _vm.info
                              ),
                              _vm.$divisions.consignmentWorkClassEnum
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("進行部門")]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "word_box", attrs: { span: 8 } },
                    [
                      _c(
                        "div",
                        { staticClass: "flex_space flex_center_align" },
                        [
                          _c("div", { staticClass: "flex_auto line_height" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getFieldValue(
                                    "purchaseOrderBaseIdModel.purchaseOrderDepCdModel.orgkj",
                                    _vm.info
                                  )
                                ) +
                                " "
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box rline", attrs: { span: 4 } },
                    [_vm._v("進行担当者")]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "word_box center_box", attrs: { span: 8 } },
                    _vm._l(
                      _vm.getFieldValue(
                        "purchaseOrderBaseIdModel.purchaseOrderChargePersonModelList",
                        _vm.info
                      ),
                      function (item, index) {
                        return _c("div", { key: index }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.getFieldValue(
                                  "empnmkj",
                                  item.chargePersonCdModel
                                )
                              ) +
                              " "
                          ),
                        ])
                      }
                    ),
                    0
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("納品予定年月")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 8 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm
                              .$dayjs(
                                _vm.getFieldValue(
                                  "demandBaseIdModel.contractEndDate",
                                  _vm.info
                                )
                              )
                              .format("YYYY/MM")
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("vab-form", { ref: "form", attrs: { model: _vm.form } }, [
        _c(
          "div",
          { staticClass: "info_main" },
          [
            _c(
              "div",
              { staticClass: "head_box flex_start flex_center_align" },
              [
                _c("svg-icon", { attrs: { "icon-class": "document_2_line" } }),
                _c("span", { staticClass: "hd_title" }, [_vm._v("詳細情報")]),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "sure_box top_info mb20" },
              [
                _c(
                  "vab-row",
                  { staticClass: "row_box" },
                  [
                    _c(
                      "vab-col",
                      { staticClass: "title_box", attrs: { span: 4 } },
                      [_vm._v("商品明細")]
                    ),
                    _c(
                      "vab-col",
                      { staticClass: "word_box", attrs: { span: 20 } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getFieldValue(
                                "purchaseOrderBaseIdModel.itemCdModel.itmdtlnm",
                                _vm.info
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "vab-row",
                  { staticClass: "row_box" },
                  [
                    _c(
                      "vab-col",
                      { staticClass: "title_box", attrs: { span: 4 } },
                      [_vm._v("発注件名")]
                    ),
                    _c(
                      "vab-col",
                      { staticClass: "word_box", attrs: { span: 20 } },
                      [
                        _c("div", { staticClass: "flex_space" }, [
                          _c("div", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getFieldValue(
                                    "purchaseOrderBaseIdModel.purchaseOrderName",
                                    _vm.info
                                  )
                                ) +
                                " "
                            ),
                          ]),
                          _c("div", { staticClass: "sub_title" }, [
                            _vm._v(
                              " （発注No：" +
                                _vm._s(
                                  _vm.getFieldValue(
                                    "purchaseOrderBaseIdModel.acceptOrderNo",
                                    _vm.info
                                  )
                                ) +
                                "） "
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "vab-row",
                  { staticClass: "row_box" },
                  [
                    _c(
                      "vab-col",
                      { staticClass: "title_box", attrs: { span: 4 } },
                      [_vm._v("提出状況")]
                    ),
                    _c(
                      "vab-col",
                      { staticClass: "word_box", attrs: { span: 20 } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getEnumText(
                                _vm.info.reportSubmitStatus,
                                _vm.$divisions.docSubmitStatusEnum
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("vab-file", { ref: "vabFile" }, [
              _c("div", { attrs: { slot: "h_title" }, slot: "h_title" }, [
                _vm._v("報告書の提出を行ってください"),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "sure_box" },
              [
                _c(
                  "vab-row",
                  { staticClass: "row_box" },
                  [
                    _c(
                      "vab-col",
                      { staticClass: "title_box", attrs: { span: 4 } },
                      [_vm._v("協力会社コメント")]
                    ),
                    _c(
                      "vab-col",
                      {
                        staticClass: "word_box nopadding2",
                        attrs: { span: 20 },
                      },
                      [
                        _c("vab-textarea", {
                          attrs: {
                            type: "textarea",
                            prop: "comment",
                            rows: "5",
                            maxlength: "2340",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("vab-message", {
                  ref: "vabMessage",
                  staticClass: "noborder no_margin",
                  attrs: {
                    title: "コメント履歴を閉じる",
                    "msg-type": _vm.$divisions.adjSourceClassEnum.enum_1.value,
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "flex_end mg12" },
              [_c("vab-button", { attrs: { "btn-list": _vm.btnList } })],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }